import {StreamComponentType} from '@Components/ai-chat-window/lib/stream-component-registry.types';
import {defineStreamComponentRegistration} from '@Components/ai-chat-window/lib/stream-component-registration';
import {parseEachOrNull} from '@Components/ai-chat-window/lib/stream-component-prop-guards';
import {isSafeWebUrl} from '@Utils/url.util';
import type {WebSource, WebSourcesProps} from './web-sources.types';
import {parseWebSourcesVariant} from './web-sources.library';
import {WebSources} from './web-sources';

const linkHostMatchesDomain = (url: string, domain: string): boolean => {
  try {
    return new URL(url).hostname.replace(/^www\./, '').toLowerCase() === domain.toLowerCase();
  } catch {
    return false;
  }
};

const parseSource = (value: Record<string, unknown>): WebSource | null => {
  if (typeof value.title !== 'string' || typeof value.url !== 'string' || typeof value.domain !== 'string' || !isSafeWebUrl(value.url) || !linkHostMatchesDomain(value.url, value.domain)) {
    return null;
  }

  return {title: value.title, url: value.url, domain: value.domain};
};

const parseWebSourcesProps = (props: Record<string, unknown>): WebSourcesProps | null => {
  if (!Array.isArray(props.sources) || props.sources.length === 0) {
    return null;
  }

  const sources = parseEachOrNull(props.sources, parseSource);

  return sources === null ? null : {variant: parseWebSourcesVariant(props.variant), sources};
};

export const webSourcesRegistration = defineStreamComponentRegistration(StreamComponentType.WEB_SOURCES, WebSources, parseWebSourcesProps);
